export default __webpack_public_path__ + "media/images/gallery/6-0213fd1927aff618c8966cfc8b0629c2.jpg";